import script from "./SlidingPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlidingPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlidingPanel.vue?vue&type=style&index=0&id=28cb5c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28cb5c46"]])

export default __exports__